import React from 'react'
import {unstable_batchedUpdates} from 'react-dom'
import { TableContext} from "@q4us-sw/q4us-ui/lib/TableV2";
import {Form} from '@q4us-sw/q4us-ui'
import {
    getFeConfig,
} from "../../api/api";
import PropTypes from "prop-types";


export const TableFilter = (props)=>{
    const [i, setI] = React.useState(props.initialValue)

    const refreshTable = React.useCallback(async (ctx, filter)=>{
        ctx?.setLoading(true)
        const res = await props.fetch(filter, {});
        unstable_batchedUpdates(() => {
            ctx?.setData(res.data?.rows || [])
            ctx?.setCustomData({filter})
            if(res.data?.page){
                ctx?.setPage({
                    current: res.data?.page?.current || ctx?.page?.current || 0,
                    total: res.data?.page?.total || ctx?.page?.total || 0,
                    size: ctx?.page?.size || ctx?.props.defaultPageSize || 100,
                    ...res.data?.page
                })
            }
            ctx?.setLoading(false)
        })
    }, [])

    return <TableContext.Consumer>
            {table => <Form
                    layout={'inline'}
                    acceptText={props.acceptText}
                    rejectText={props.rejectText}
                    schema={props.schema}
                    initialValue={i}
                    maxHeight={95}
                    config={async (schema) => {
                        const res = await getFeConfig(schema)
                        return res.data.rows;
                    }}
                    submit={async (filter) => {
                        setI(undefined)
                        await refreshTable(table, filter)
                        return false;

                    }}
                    rejected={async (form) => {
                        setI(undefined)
                        form.resetFields()
                        await refreshTable(table, {})
                    }}
                />}
        </TableContext.Consumer>
}

TableFilter.propTypes = {
    schema: PropTypes.string,
    initialValue: PropTypes.any,
    fetch: PropTypes.func,
    acceptText: PropTypes.string,
    rejectText: PropTypes.string
}

TableFilter.defaultProps = {
    acceptText: "Filter",
    rejectText: "Clear"
}
